import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { hooks } from '@lifesize/clients.sdk';
import { RootState } from 'store/reducers';
import RingTone, { RingType } from 'components/Ringer/RingTone';
import { callState } from 'constants/Guest';
import { isFarEndBusy } from 'utils/call-utils';

let busySignalTimeout: NodeJS.Timeout;

export default function Ringer() {
  const call = hooks.useCallState();
  const isRinging = callState.calling.includes(call.state);
  const mediaSettings = useSelector((state: RootState) => state.app.mediaSettings);
  const [playBusySignal, setPlayBusySignal] = useState(false);

  const cancelBusySignal = useCallback(() => {
    clearTimeout(busySignalTimeout);
    setPlayBusySignal(false);
  }, []);

  useEffect(() => {
    if (isFarEndBusy(call)) {
      setPlayBusySignal(true);
      busySignalTimeout = setTimeout(() => {
        setPlayBusySignal(false);
      }, 4600);
    } else {
      cancelBusySignal();
    }
    return () => {
      cancelBusySignal();
    };
  }, [cancelBusySignal, call]);

  return (
    <>
      {isRinging && <RingTone deviceId={mediaSettings.speakers} />}
      {playBusySignal && <RingTone deviceId={mediaSettings.speakers} ringType={RingType.busy} />}
    </>
  );
}
